import { displayLatLonInCompassFormat } from '@deckee/utilities';
import React from 'react';
import { lightHouse } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Lighthouse',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'lighthouse',
  icon: {
    baseShape: lightHouse,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'lighthouseMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Lighthouse',
      itemTitleFunction: (item) => (item && item.title) || 'Lighthouse',
    },
    creationOptions: {
      menuText: 'Lighthouse',
      newTitle: 'Lighthouse location',
      titlePlaceholder: 'Name of lighthouse',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate the location of a lighthouse or light
          marker. Include information such as flashing timing, the distance it
          can be seen, and height above sea level.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Lighthouse location',
    description: displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
